/**
 * Extract error message from API error response
 * Handles Pydantic validation errors which return array of objects
 */
export const getErrorMessage = (error, defaultMessage = 'An error occurred') => {
  const detail = error?.response?.data?.detail;
  
  if (!detail) {
    return error?.message || defaultMessage;
  }
  
  // String error message
  if (typeof detail === 'string') {
    return detail;
  }
  
  // Pydantic validation error (array of objects with {type, loc, msg, input, ctx})
  if (Array.isArray(detail) && detail.length > 0) {
    const firstError = detail[0];
    if (firstError?.msg) {
      // Format: "field: message" if location is available
      const field = firstError.loc?.slice(-1)[0];
      return field ? `${field}: ${firstError.msg}` : firstError.msg;
    }
    return defaultMessage;
  }
  
  // Single object with msg property
  if (detail?.msg) {
    return detail.msg;
  }
  
  // Unknown format - return default
  return defaultMessage;
};
